// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountMedicalBenefitModels {
    static getAttributeTypeMap() {
        return PayorAccountMedicalBenefitModels.attributeTypeMap;
    }
}
PayorAccountMedicalBenefitModels.discriminator = undefined;
PayorAccountMedicalBenefitModels.additionalProperties = false;
PayorAccountMedicalBenefitModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=payorAccountMedicalBenefitModels.js.map